export class DropDownConstantsFactory {
 public static createStandardClientDropdownSettings() {
    return {
      text: 'name',
      value: 'id'
    };
 }

  public static createEnumDropdownSettings() {
    return {
      text: 'value',
      value: 'key'
    };
  }

  public static createNumericEnumDropdownSettings() {
    return {
      text: 'text',
      value: 'value'
    };
  }
}
